import Vue from "vue";
import { playRewardedAd } from "js/crossword/sdk/playRewardedAd";
import { PrintType } from "js/crossword/html/types";
import { trackPrint } from "js/tracking/track";
import { Provider } from "js/crossword/types";
import { RadioButton } from "./FormElements";
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  data() {
    return {
      showingAd: false,
      printed: false,
      error: false,
      printOptions: {
        type: PrintType.Blank,
      },
    };
  },
  methods: {
    watchAd() {
      this.showingAd = true;

      playRewardedAd()
        .then((success) => {
          if (success) {
            this.$emit("printPuzzle", this.printOptions.type);
            trackPrint(this.printOptions.type);
            this.printed = true;
          } else {
            this.printed = false;
            this.error = true;
          }
        })
        .finally(() => {
          this.showingAd = false;
        });
    },
  },
  render() {
    const onClose = !this.showingAd ? () => this.$emit("close") : () => {};

    return (
      <PopupContainer customClasses={["popup--print"]} handleClose={onClose}>
        <div class="adPopup--content-wrapper">
          <div>
            {!this.error ? (
              <img class="adPopup--icon" src="images/Print_Icon.svg" />
            ) : (
              <img class="adPopup--icon" src="images/Print_Error.svg" />
            )}

            {this.printed
              ? <img class="printPopup__checkIcon" src="images/Check_Mark.svg" />
              : null
            }

          </div>
          {this.printed && (
            <div>
              {this.localization.get("Your puzzle has been")} <b>{this.localization.get("printed")}</b>.
            </div>
          )}
          {(!this.printed && !this.error) && (
            <div>
              <b>{this.localization.get("Watch an ad")}</b> {this.localization.get("and print your puzzle.")}
            </div>
          )}
          {this.error && (
            <div>
              <b>
                {this.localization.get("We found an error when trying to print.")}
              </b>
              <p>
                {this.localization.get("If you have an ad blocker please disable it and refresh the page.")}
              </p>
            </div>
          )}
        </div>

        {!this.printed && !this.error
          ? (
            <div class="printPopup__typeInputContainer">
              <RadioButton
                label={this.localization.get("Blank puzzle")}
                inputPosition="left"
                target={this.printOptions}
                targetKey="type"
                value={PrintType.Blank} />

              <div style={{ marginLeft: "1em" }}></div>

              <RadioButton
                style={{ maxWidth: "36%" }}
                label={this.localization.get("With entries")}
                inputPosition="left"
                target={this.printOptions}
                targetKey="type"
                value={PrintType.Entries} />

              <div style={{ marginLeft: "1em" }}></div>

              <RadioButton
                label={this.localization.get("Solution")}
                inputPosition="left"
                target={this.printOptions}
                targetKey="type"
                value={PrintType.Solution} />
            </div>
          ) : (
            <div class="printPopup__typeInputContainer"></div>
          )
        }
        {this.error && (
          <div class="printPopup__typeInputContainer"></div>
        )}

        {!this.error && (
          <PopupButtons buttons={[{
            disabled: this.showingAd,
            label: this.localization.get(this.printed ? "Resume" : "Print"),
            onClick: () => this.printed ? this.$emit("close") : this.watchAd(),
          }]} />
        )}
      </PopupContainer>
    );
  },
});
